<template>
  <section class="cta section center-content-mobile" :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
    <div class="container">
      <div class="cta-inner section-inner reveal-from-bottom" :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider',
                    split && 'cta-split'
                ]">
        <div class="cta-slogan">
          <h3 class="m-0">
            {{ $t('visit-us') }}
          </h3>
                    <h4>
            <a href="https://www.facebook.com/people/Struvital-Smart-Farming/61558921637610/#" target="_blank">
              <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <title>Facebook</title>
                <path
                  d="M6.023 16L6 9H3V6h3V4c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V6H13l-1 3H9.28v7H6.023z" />
              </svg>
            </a>
          </h4>
        </div>
        <div class="cta-action">
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
// import CButton from '@/components/elements/Button.vue'

export default {
  name: 'CCta',
  components: {
    // CButton
  },
  mixins: [SectionProps],
  props: {
    split: {
      type: Boolean,
      default: false
    }
  }
}
</script>